<template>
  <div class="checkboxes-list">
    <div
      class="checkbox-container"
      :key="`cb_${i}`"
      v-for="(option, i) in computedOptions"
    >
      <input
        :id="$id(underSlugify(option.label))"
        type="checkbox"
        :value="option.value"
        v-model="computedValue"
      />
      <label :for="$id(underSlugify(option.label))">{{ option.label }}</label>
      <div class="below-checkbox" v-if="option.belowCheckboxComponent">
        <component
          :is="option.belowCheckboxComponent"
          :class="option.belowCheckboxComponentClasses"
          v-bind.sync="option.belowCheckboxComponentData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsesOptions from "../../elements/UsesOptions";

export default {
  name: "CheckboxesList",
  extends: UsesOptions,
  props: {
    value: Array
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkboxes-list {
  .checkbox-container {
    @apply border border-lightgray py-3 px-4;

    &:nth-child(odd) {
      @apply bg-white;
    }

    &:nth-child(even) {
      @apply bg-lightgray-lightest;
    }

    &:not(:first-child) {
      @apply border-t-0;
    }
  }
}
</style>
